var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.appClasses,attrs:{"id":"app","data-variants":_vm.variant}},[_c('main',{staticClass:"main"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{ref:"router"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }